/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var DataChartBarsAUpIcon20Light = forwardRef('DataChartBarsAUpIcon20Light', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 20 }, props),
        React.createElement("path", { d: "M16 3.5a.5.5 0 0 0-1 0v13a.5.5 0 0 0 1 0v-13Z" }),
        React.createElement("path", { d: "M12 6.5a.5.5 0 0 0-1 0v10a.5.5 0 0 0 1 0v-10Z" }),
        React.createElement("path", { d: "M4 12a.5.5 0 0 0-1 0v4.5a.5.5 0 0 0 1 0V12Z" }),
        React.createElement("path", { d: "M7.5 8.5A.5.5 0 0 1 8 9v7.5a.5.5 0 0 1-1 0V9a.5.5 0 0 1 .5-.5Z" })));
});
